import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
/**
 * Конфигурация oidc для подключения к identity server 4
 * oidc configuration for connection to identity server 4
 */
export const AuthConfiguration: AuthConfig = {
    /**
     * Адрес выписывающего гаранта
     * Issuer garant address
     */
    issuer: environment.issuerAuthority,
    /**
     * Адрес переадресации после аутентификации
     * Redirect address after authentication
     */
    redirectUri: environment.selfRedirect,
    /**
     * Идентификатор этого клиента
     * This client's identifier
     */
    clientId: 'CCAdminAngularClient',
    /**
     * Использовать openid-connect преимущественно перед oauth2
     * Use openid-connect over the oauth2
     */
    oidc: true,
    /**
     * Явно запрашивать только защищенное ssl подключение
     * Directly require only protected ssl connection
     */
    requireHttps: false,
    /**
     * Необходимые права для этого клиента
     * Required scopes for this client
     */
    scope: 'openid profile ccindicatorsapi account_information roles email',
    /**
     * Проверять активную сессию
     * Check active session
     */
    sessionChecksEnabled: true
}